import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import BaseRootOption from "%/dynamic-component-editor/classes/base-root-option";

export default class LinkedOptionVariables extends BaseRootOption {
  static userInterfaceComponent = () => {
    return {
      label: "Options Variables",
      component: inspectorTools.NONE,
    };
  };

  static defaultValue = {};
}
